import BoldText from '@/components/BoldText';
import { Card, DataTable } from '@shopify/polaris';

interface IProps {
  title?: string;
  renderRows: (JSX.Element | null)[][];
  className?: string;
  style?: React.CSSProperties;
}

const CutOffTimeConfig = ({ title, renderRows, className, style }: IProps) => {
  return (
    <div className={className} style={style}>
      {title ? <BoldText>{title}</BoldText> : null}
      <Card padding="0">
        <DataTable
          columnContentTypes={['text', 'text', 'text']}
          headings={[<BoldText key={'workday'}>Workday</BoldText>, <BoldText key="cutOff">Cut-off time (hh:mm)</BoldText>, '']}
          verticalAlign="middle"
          rows={renderRows}
        />
      </Card>
    </div>
  );
};

export default CutOffTimeConfig;
